export default __webpack_public_path__ + "static/media/Catch.070c0fcb.mp3";